import { createFileRoute } from "@tanstack/react-router"
import { AixContentBody } from "@aix/ui"
import { useAtomValue } from "jotai"
import { BreadcrumbBanner } from "~/components/BreadcrumbBanner"
import AIStoryTemplate from "~/components/Templates/AIStoryTemplate"
import AppLayout from "~/layouts/AppLayout"
import CustomHead from "~/components/SEOHead/CustomHead"
import { navStyleAtom } from "~/context/jotai"
import { getPageSEO } from "~/utils/seo"

const CreateVideoPage = () => {
  const breadcrumbItems = [{ label: "Home", href: "/home" }, { label: "AI Story" }]
  const aiStorySEO = getPageSEO("templates/ai-story")
  const navStyle = useAtomValue(navStyleAtom)

  return (
    <>
      <CustomHead
        title={aiStorySEO.title}
        description={aiStorySEO.description}
        keywords={aiStorySEO.keywords}
        pageType={aiStorySEO.pageType}
        url="https://vidmax.ai/templates/ai-story"
      />

      {navStyle !== "twoTier" && <BreadcrumbBanner items={breadcrumbItems} />}

      <AixContentBody className="sm:[--content-max-width:500px] md:[--content-max-width:700px] xl:[--content-max-width:960px]">
        <AIStoryTemplate />
      </AixContentBody>
    </>
  )
}

function CreateVideoPageWrapper() {
  return (
    <AppLayout>
      <CreateVideoPage />
    </AppLayout>
  )
}

export const Route = createFileRoute("/templates/ai-story")({
  component: CreateVideoPageWrapper,
})
